import { render, staticRenderFns } from "./validated-list.vue?vue&type=template&id=70cac3b4&"
import script from "./validated-list.vue?vue&type=script&lang=js&"
export * from "./validated-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cac3b4')) {
      api.createRecord('70cac3b4', component.options)
    } else {
      api.reload('70cac3b4', component.options)
    }
    module.hot.accept("./validated-list.vue?vue&type=template&id=70cac3b4&", function () {
      api.rerender('70cac3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/validated-list.vue"
export default component.exports